import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// components
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import { Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useHistory, useLocation, Link } from "react-router-dom";

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";
import "react-toastify/dist/ReactToastify.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import CVDownloadGreen from "./../../../../assets/img/DashboardICons/CVDwonloadGreen.svg";

const StaffColleaguesInfoNotifDetailInfo = () => {
  const { state } = useLocation();
  const { userToken } = useContext(UserContext);
  const history = useHistory();
  const [cursor, setCursor] = useState("pointer");
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [btnLoader, setBtnLoader] = useState({
    accept: false,
    reject: false,
  });

  // Form State
  const [formStaffColleaguesInfo, setFormStaffColleaguesInfo] = useState({
    fullName: "",
    education: "",
    callNumber: "",
    address: "",
    email: "",
    description: "",
    formBirthDate: "",
    formRegistryDate: "",
    CV: "",
  });

  useMemo(() => formStaffColleaguesInfo, [formStaffColleaguesInfo]);

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)

      const getConsultant = await axios.get(
        // `Consultant/${state.id}`,
        `Consultant/GetConsultantById/${state.id}`,
        {
          headers: { authorization: "Bearer " + userToken },
        }
      );

      const consultant = getConsultant.data.data;
      setFormStaffColleaguesInfo(prev => {
        return {
          ...prev,
          fullName: consultant.fullName,
          education: consultant.education,
          address: consultant.address,
          callNumber: consultant.phoneNumber,
          email: consultant.email,
          description: consultant.aboutMe,
          formBirthDate: consultant.birthDate,
          formRegistryDate: consultant.registerDate,
          CV: consultant.cvImageName,
        };
      });
      // console.log(consultant)

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken, state.id]);

  return (
    <>
      <style>
        {`
                    .rmdp-input {
                        color: #363636;
                        font-size: 16px;
                        border: 1px solid #e1e1e1;
                        border-radius: 100px;
                        height: auto;
                        padding: 11px 15px;
                        box-sizing: border-box;
                        transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                        box-shadow: none;
                        width: 100%;
                    }
                    .rmdp-input:focus {
                        border-color: #21409a;
                        box-shadow: none;
                    }
                    .rmdp-wrapper {
                        width: 100% !important;
                        box-shadow: none !important;
                        border: 1px solid #e1e1e1;
                        border-radius: 24px;
                    }
                    .rmdp-wrapper input {
                        font-size: 24px !important;
                        width: 45px !important;
                        color: #363636 !important;
                    }
                    .dvdr{
                        font-size: 35px !important;
                        color: #D9D9D9 !important;
                    }
                    `}
      </style>

      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover={false}
            theme="light"
          />
          <div className="row">
            <div className="col-md-9">
              <div className={`my-3 px-0 pb-4 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2 pb-4" dir="rtl">
                  <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>{formStaffColleaguesInfo.fullName}</div>
                  </div>
                </div>

                {/* Staff Colleagues Info Details */}

                <div dir="rtl" className={`text-right mx-4 px-4 ${styles.total_staff_colleagues_notif_detail_box}`}>
                  <div className={`pt-1 pb-5 position-relative`}>
                    <div className={`d-flex justify-content-between align-items-start flex-wrap mt-2 mb-2 pt-4 pb-1`}>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="fullName">
                          {" "}
                          نام و نام‌خانوادگی{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          id="fullName"
                          name="fullName"
                          value={formStaffColleaguesInfo.fullName}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="birthDate">
                          {" "}
                          تاریخ تولد{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          id="formBirthDate"
                          name="formBirthDate"
                          value={formStaffColleaguesInfo.formBirthDate}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="education">
                          {" "}
                          تحصیلات{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          id="education"
                          name="education"
                          value={formStaffColleaguesInfo.education}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="callNumber">
                          {" "}
                          شماره تماس{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          id="callNumber"
                          name="callNumber"
                          value={formStaffColleaguesInfo.callNumber}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="registryDate">
                          {" "}
                          تاریخ عضویت{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          id="formRegistryDate"
                          name="formRegistryDate"
                          value={formStaffColleaguesInfo.formRegistryDate}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="address">
                          {" "}
                          آدرس{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="text"
                          id="address"
                          name="address"
                          value={formStaffColleaguesInfo.address}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="email">
                          {" "}
                          ایمیل{" "}
                        </Form.Label>
                        <Form.Control
                          className={`${styles.form_control_input} shadow-none`}
                          type="email"
                          id="email"
                          name="email"
                          value={formStaffColleaguesInfo.email}
                        />
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`}> رزومه </Form.Label>
                        <div
                          className={`${styles.form_control_input} shadow-none text-center`}
                          role="button"
                          onClick={handleDownload}
                          style={{ cursor: cursor }}>
                          <img src={CVDownloadGreen} alt="cv-download-icon" />
                          <span className={`pe-2 ${styles.form_text_cv_download}`}> دانلود رزومه </span>
                        </div>
                      </Form.Group>
                      <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column w-100`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="description">
                          {" "}
                          توضیحات{" "}
                        </Form.Label>
                        <Form.Control
                          style={{ resize: "none" }}
                          className={`${styles.form_control_input} shadow-none`}
                          as="textarea"
                          rows={7}
                          id="description"
                          name="description"
                          value={formStaffColleaguesInfo.description}
                        />
                      </Form.Group>
                    </div>

                    <div className="d-flex justify-content-end align-items-center mt-4 mb-2">
                      {btnLoader.reject ? (
                        <div className={styles.btn_loader_container}>
                          <div className={styles.btn_spinner}></div>
                        </div>
                      ) : (
                        <div
                          className={`${styles.total_delete_btn} text-center d-flex justify-content-center align-items-center ms-3`}
                          role="button"
                          onClick={rejectConsultant}>
                          <button style={{ color: "#e00000" }} className={`border-0 bg-transparent`}>
                            رد درخواست کننده
                          </button>
                        </div>
                      )}

                      {btnLoader.accept ? (
                        <div className={styles.btn_loader_container}>
                          <div className={styles.btn_spinner}></div>
                        </div>
                      ) : (
                        <div
                          className={`${styles.total_save_btn} text-center d-flex justify-content-center align-items-center me-3`}
                          role="button"
                          onClick={acceptCosultant}>
                          <button className={`border-0 bg-transparent text-white`}>قبول</button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu managePersonal manageStaffInfo />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  async function handleDownload() {
    setCursor("wait");
    const fileType = formStaffColleaguesInfo.CV.split(".");
    try {
      const response = await axios({
        url: `https://backdev.azrmelk.com/api/Consultant/DownloadFile/${formStaffColleaguesInfo.CV}`,
        method: "GET",
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `file.${fileType[1]}`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      // console.log(error);
      notify("فایل یافته نشد", "error");
    }
    setCursor("pointer");
  }

  async function acceptCosultant() {
    setBtnLoader(prev => {
      return { ...prev, accept: true };
    });
    try {
      var data = {
        consultantId: state.id,
      };

      const acceptCosultant = await axios.post("Consultant/AcceptConsultant", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(acceptCosultant)
      notify(`کاربر ${formStaffColleaguesInfo.fullName} قبول شد`, "success");
      setBtnLoader(prev => {
        return { ...prev, accept: false };
      });
      // history.push('/staff-managment-colleagues-info')
    } catch (error) {
      notify("خطایی رخ داد", "error");
      // history.push('/staff-managment-colleagues-info')
    }
  }

  async function rejectConsultant() {
    setBtnLoader(prev => {
      return { ...prev, reject: true };
    });
    try {
      var data = {
        consultantId: state.id,
        reason: "",
      };

      const rejectConsultant = await axios.post("Consultant/RejectConsultant", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(rejectConsultant)
      notify(`کاربر ${formStaffColleaguesInfo.fullName} رد شد`, "error");
      setBtnLoader(prev => {
        return { ...prev, accept: false };
      });
      // history.push('/staff-managment-colleagues-info')
    } catch (error) {
      notify("خطایی رخ داد", "error");
      // history.push('/staff-managment-colleagues-info')
    }
  }
};

export default StaffColleaguesInfoNotifDetailInfo;
